<template>
    <div class="arterra-gallery col-xs-12 col-md-8">
        <swiper :options="swiperOption" class="swiper" ref="mySwiper">
            <swiper-slide
                    v-for="(item, key) in items"
                    :key="item.id"
                    :data-hash="'item-'+key"
            >
                <div @click="selectItem(key)">
                    <div class="sw-img" v-bind:style="{backgroundImage: 'url('+item.contentable.thumb_url+')'}" />
                    <div class="name">{{ item.name }}</div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="highlight">
            <div class="hl-img" v-bind:style="{backgroundImage: 'url('+curItem.contentable.thumb_url+')'}">
                <div v-bind:style="{backgroundImage: 'url('+curItem.contentable.preview_url+')'}">
                    <div class="hl-prev" @click="goPrev"></div>
                    <div class="hl-zoom" @click="openZoom=true"></div>
                    <div class="hl-next" @click="goNext"></div>
                </div>
            </div>
            <div class="name">{{ curItem.name }}</div>
        </div>
        <div class="hidden">
            <slot></slot>
        </div>

        <portal to="footer" v-if="openZoom">
            <div class="viewer" @click="openZoom=false">
                <div class="img-wrap" v-bind:style="{backgroundImage: 'url('+curItem.contentable.preview_url+')'}"><img :src="curItem.contentable.preview_url" /></div>
                <div class="backdrop"></div>
            </div>
        </portal>
    </div>
</template>

<script>

    import Vue from 'vue';

    import PortalVue from 'portal-vue'
    Vue.use(PortalVue)

    import 'swiper/dist/css/swiper.css'

    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        components: {
            swiper,
            swiperSlide
        },
        data: function(){
            return {
                openZoom: false,
                selectedIndex: parseInt(Object.keys(this.items)[0]),
                swiperOption: {
                    hashNavigation: true,
                    slidesPerView: 4,
                    spaceBetween: 10,
                    centeredSlides: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        dynamicBullets: true,
                    }
                }
            };
        },
        methods: {
            selectItem: function(key)
            {
                this.selectedIndex = key;
                this.swiper.slideTo(key);
            },
            goNext: function(e, n = 1){
                this.selectItem( ( this.selectedIndex + n + this.items.length ) % this.items.length );
            },
            goPrev: function(){
                this.goNext(null, -1);
            },
            goZoom: function(){

            },
        },
        computed: {
            curItem: function(){
                return this.items[this.selectedIndex]
            },
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        props: {
            items: { type: Array,  required: true },
        }
    };
</script>

<style lang="scss" scoped>
    .arterra-gallery {
        margin: 10px 0;
    }
    .highlight {
        .hl-img, .hl-img>div {
            height: 480px;
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
        }
        .hl-next, .hl-prev {
            height: 480px;
            position: absolute;
            width: 20%;
            &:hover {
               background: rgba(255,255,255,.1);
            }
            cursor: pointer;
        }
        .hl-zoom {
            cursor: pointer;
            height: 480px;
            position: absolute;
            width: 60%;
            left: 20%;
        }
        .hl-next {
            left: 80%;
        }
        .name {
            padding: 20px;
            text-align: center;
            font-size: 16px;
        }
    }
    .swiper {
        .sw-img {
            width: 100%;
            height: 160px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
        .name {
            padding: 10px;
            text-align: center;
            font-size: 14px;
        }
    }
    .viewer {
        z-index: 1000;
        display: block;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        .backdrop {
            top: 0;
            left: 0;
            z-index: 1001;
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,.8);
        }

        .img-wrap {
            width: 100%;
            height: 100%;
            background-position: center center;
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            z-index: 1002;
            img {
                display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Gallery.vue